// removed by extract-text-webpack-plugin
module.exports = {"org-switcher":"org-switcher---2uV8k","organization-info-container":"organization-info-container---1lCLg","organization-global-name":"organization-global-name---2eF6A","org-switcher-header":"org-switcher-header---34-6n","org-switcher-provision":"org-switcher-provision---1Vx_i","org-switcher-increment":"org-switcher-increment---2_5mW","org-logo":"org-logo---3s9GA","organization-access-right":"organization-access-right---3djql"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/MainNav/AppSwitcher/Organizations/styles.css
// module id = qUe4
// module chunks = 89